export interface CurrentUser {
  userName: string;
  userId: string;
}
